import appInfo from '../app-info';
import { apiHelper, call_post_api } from './api_helper';
export async function chamsockhachhang_select_all(dk) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/select_all', dk);
};

export async function chamsockhachhang_get_info_by_phone(phone) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/get_info_by_phone', phone);
};

export async function chamsockhachhang_select_by_id(id) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/select_by_id', id);
};
export async function chamsockhachhang_select_by_coso_namhoc(dm_coso_id, nam_hoc) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/select_by_coso_namhoc', dm_coso_id, nam_hoc);
};
export async function chamsockhachhang_insert(data) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/insert', data);
}

export async function chamsockhachhang_update(data) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/update', data);
}

export async function chamsockhachhang_remove(id) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/delete', id);
}

export async function chamsockhachhang_change_status(data) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/change_status', data);
}

export async function chamsockhachhang_select_by_hoc_sinh_id(ts_hocsinh_id) {
    return call_post_api(appInfo.api_url + '/chamsockhachhang/select_by_hoc_sinh_id', ts_hocsinh_id);
};

export const chamSocKhachHangApi = {
    SelectAll: () => apiHelper.get(`cskh`),
    SelectByHocSinh: (ts_hocsinh_id) => apiHelper.get(`cskh/select-by-hs/${ts_hocsinh_id}`),
    SelectByCoSoNamHoc: (data) => apiHelper.post(`cskh/select-by-coso-namhoc`, data),
    Select: (data) => apiHelper.post(`cskh/select`, data),
    Insert: (data) => apiHelper.post('cskh',data),
    Update: (data) => apiHelper.put('cskh',data),
    Delete: (id) => apiHelper.delete(`cskh/${id}`),
    Detail: (id) => apiHelper.get(`cskh/${id}`),
}